import classJoin from 'classjoin';
import {h} from 'preact';
import MobileVisualBuilding from './MobileVisualBuilding';
import MobileVisualFloor from './MobileVisualFloor';
import MobileVisualOverview from './MobileVisualOverview';
import {setFilterVisibility} from './Store/creators/visualData';
import {dispatch} from './Store/index';
import {StateVisualStep} from './Store/State';
import Visual, {VisualProps, VisualState} from './Visual';

/**
 * Визуальный режим на мобильном устройстве.
 */
class MobileVisual extends Visual
{
	/**
	 * Rendered component mounted to the DOM.
	 */
	public componentDidMount(): void
	{
		dispatch( setFilterVisibility( false ) );
	}
	
	/**
	 * Before component will be unmounted and destroyed.
	 */
	public componentWillUnmount(): void
	{
		
	}
	
	/**
	 * Render component.
	 */
	public render(
		_props: VisualProps,
		{
			overview, building, section, floor, step, filterVisible,
			filterChanged,
		}: VisualState,
	): JSX.Element
	{
		let stepElement: JSX.Element;
		
		switch ( step )
		{
			case StateVisualStep.BUILDING:
				stepElement = (
					<MobileVisualBuilding
						{...building}
					/>
				);
				break;
			
			case StateVisualStep.FLOOR:
				stepElement = (
					<MobileVisualFloor
						building={building.building}
						section={section.section}
						background={section.image}
						floorsCount={section.map.length}
						{...floor}
					/>
				);
				break;
			
			default:
				stepElement = (
					<MobileVisualOverview
						{...overview}
					/>
				);
				break;
			}
		
		return (
			<div class="visual">
				<div class="controls">
					<button
						type="button"
						class="view-list"
						onClick={this.onViewListClick}
					>
						Квартиры списком
					</button>
					<button
						type="button"
						class={
							classJoin(
								{
									changed: ( filterChanged && !filterVisible ),
									opened: filterVisible,
								},
								['toggle-filter'],
							)
						}
						onClick={this.onToggleFilterClick}
					>
						{
							filterVisible
							? (
								'Применить фильтры'
							)
							: (
								<svg role="img"
									title="Показать фильтр"
									width="23"
									height="20"
								>
									<use xlinkHref="/images/icons.svg#options-small" />
								</svg>
							)
						}
					</button>
				</div>
				{stepElement}
			</div>
		);
	}
	
}

/**
 * Module.
 */
export {
	MobileVisual as default,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/MobileVisual.tsx